
import Overlay from '../../../components/Overlay.vue';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { defineComponent, reactive, toRefs } from 'vue';
import VChart from 'vue-echarts';

use([
  BarChart,
  CanvasRenderer,
  SVGRenderer,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
]);

export default defineComponent({
  name: 'DashboardBilledReserved',

  components: {
    Overlay,
    VChart,
  },

  props: {
    shoesb: {
      type: Array,
      default: () => [0, 0, 0, 0, 0, 0, 0],
    },
    shoesr: {
      type: Array,
      default: () => [0, 0, 0, 0, 0, 0, 0],
    },
    confectionb: {
      type: Array,
      default: () => [0, 0, 0, 0, 0, 0, 0],
    },
    confectionr: {
      type: Array,
      default: () => [0, 0, 0, 0, 0, 0, 0],
    },
    accessoryb: {
      type: Array,
      default: () => [0, 0, 0, 0, 0, 0, 0],
    },
    accessoryr: {
      type: Array,
      default: () => [0, 0, 0, 0, 0, 0, 0],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    weekDays: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    const propsRefs = toRefs(props);
    const state = reactive({
      options: {
        grid: {
          right: '1',
          left: '1',
          top: '55',
          bottom: '40',
        },
        tooltip: {},
        yAxis: {
          show: false,
          splitLine: {
            show: false,
          },
        },
        xAxis: [
          {
            position: 'bottom',
            type: 'category',
            stack: 'billedreserved',
            data: propsRefs.weekDays,
            interval: 1,
            axisLabel: {
              margin: 20,
              fontSize: 12,
            },
          },
        ],

        series: [
          {
            name: 'Faturado Calçado',
            type: 'bar',
            stack: 'shoes',
            data: propsRefs.shoesb,
            itemStyle: {
              color: '#FF6A13',
            },
            label: {
              show: true,
              position: 'insideTop',
              align: 'center',
              verticalAlign: 'top',
              distance: 5,
              color: '#000',
              formatter: (i: any) => (i.value == 0 ? '' : i.value),
              fontSize: 10,
            },
          },
          {
            name: 'Reservado Calçado',
            type: 'bar',
            stack: 'shoes',
            data: propsRefs.shoesr,
            itemStyle: {
              color: '#00AFD7',
            },
            label: {
              show: true,
              position: 'insideTop',
              align: 'center',
              verticalAlign: 'top',
              distance: 5,
              color: '#000',
              formatter: (i: any) => (i.value == 0 ? '' : i.value),
              fontSize: 10,
            },
          },
          {
            name: 'Faturado Confecção',
            type: 'bar',
            stack: 'confection',
            data: propsRefs.confectionb,
            itemStyle: {
              color: '#CB3645',
            },
            label: {
              show: true,
              position: 'insideTop',
              align: 'center',
              verticalAlign: 'top',
              distance: 5,
              color: '#fff',
              formatter: (i: any) => (i.value == 0 ? '' : i.value),
              fon0tSize: 10,
            },
          },
          {
            name: 'Reservado Confecção',
            type: 'bar',
            stack: 'confection',
            data: propsRefs.confectionr,
            itemStyle: {
              color: '#C1E54E',
            },
            label: {
              show: true,
              position: 'insideTop',
              align: 'center',
              verticalAlign: 'top',
              distance: 5,
              color: '#000',
              formatter: (i: any) => (i.value == 0 ? '' : i.value),
              fontSize: 10,
            },
          },
          {
            name: 'Faturado Acessório',
            type: 'bar',
            stack: 'accessory',
            data: propsRefs.accessoryb,
            itemStyle: {
              color: '#8E44AD',
            },
            label: {
              show: true,
              position: 'insideTop',
              align: 'center',
              verticalAlign: 'top',
              distance: 5,
              color: '#fff',
              formatter: (i: any) => (i.value == 0 ? '' : i.value),
              fontSize: 10,
            },
          },
          {
            name: 'Reservado Acessório',
            type: 'bar',
            stack: 'accessory',
            data: propsRefs.accessoryr,
            itemStyle: {
              color: '#FFC700',
            },
            label: {
              show: true,
              position: 'insideTop',
              align: 'center',
              verticalAlign: 'top',
              distance: 5,
              color: '#000',
              formatter: (i: any) => (i.value == 0 ? '' : i.value),
              fontSize: 10,
            },
          },
        ],
      },
    });

    return { ...toRefs(state) };
  },
});
